import { loaders } from 'entities';

import { Modal, Skeleton } from 'components/Blocks';

import { useOnScreen, useToggleV2 } from 'hooks';

import { cn } from 'styles';

interface FileDisplayProps {
  url: string;

  className?: string;
}

export function PrivateImage({ url, className }: FileDisplayProps) {
  const [zoomOn, zoomHandlers] = useToggleV2();
  const [isLoaded, loadedHandlers] = useToggleV2();

  const [isOnScreen, ref] = useOnScreen();

  const { data } = loaders.uploads.getPublicUrl.use({
    blockLoad: !isOnScreen,

    params: {
      url,
    },
  });

  const renderImage = data?.url;

  return (
    <>
      {renderImage && zoomOn && (
        <Modal isOpen={zoomOn} close={zoomHandlers.turnOff} className="max-w-max p-0" allowEscape>
          <img
            src={data?.url || url}
            alt=""
            className="max-h-[90vh] max-w-[90vw] rounded-md object-cover"
          />
        </Modal>
      )}

      <button
        ref={ref}
        className={cn(
          'relative size-full rounded-md transition-opacity hover:opacity-65',
          className,
        )}
        onClick={zoomHandlers.turnOn}
      >
        <img
          src={data?.url || url}
          alt=""
          onLoad={loadedHandlers.turnOn}
          className="size-full rounded-md object-cover"
        />

        {!isLoaded && <Skeleton className="absolute inset-0" height="100%" />}
      </button>
    </>
  );
}
